// Pestaña Movimiento de la fila PCF: libro de tarjetas de todas las tiendas (o la del filtro), por fecha.
import { userMessageOf } from '@/api/errors';
import { useContextCardLedger, type CardStockContext } from './CardStockTab';
import { DetailCard, DetailEmpty } from './DetailCard';
import { ledgerCountLabel, LedgerTable } from './LedgerTable';

export function CardMovementsTab({ ctx }: { ctx: CardStockContext }) {
    const { ledger, entries } = useContextCardLedger(ctx);
    if (ctx.retailerId === null) {
        return (
            <DetailEmpty>
                No podemos leer las tarjetas sin una cadena asignada a tu usuario.
            </DetailEmpty>
        );
    }
    return (
        <DetailCard
            title="Libro de movimientos"
            aside={ledger.data ? ledgerCountLabel(entries.length) : undefined}
            flush
        >
            <LedgerTable
                entries={entries}
                stores={ctx.stores}
                state={{
                    isPending: ledger.isPending,
                    error: ledger.error,
                    hasNextPage: ledger.hasNextPage,
                    isFetchingNextPage: ledger.isFetchingNextPage,
                    onLoadMore: () => void ledger.fetchNextPage(),
                    onRetry: () => void ledger.refetch(),
                    errorTitle: 'No se pudo leer el libro de tarjetas',
                    errorMessage: userMessageOf,
                }}
                emptyText={
                    ctx.storeId
                        ? 'Sin movimientos de tarjetas en esta tienda.'
                        : 'Ninguna tienda de tu cadena tiene movimientos de tarjetas.'
                }
                showIdentifier={false}
            />
        </DetailCard>
    );
}
